import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/layout';
import Static from '../components/static';
import Heading from '../components/heading';
import definitions2 from '../data/definitions2';

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <Static>
            <Helmet title="Terms and Knowledge" meta={[{ property: 'og:title', content: 'Terms and Knowledge' }]} />
            <Heading>Terms and Knowledge</Heading>
            <div>
                {Object.keys(definitions2).sort((a, b) => {
                    const alower = a.toLowerCase();
                    const blower = b.toLowerCase();
                    if (alower < blower) return -1;
                    if (blower < alower) return 1;
                    return 0;
                }).map(term => (
                    <div css={{ display: 'flex', marginBottom: 24, '@media(max-width: 767px)': { flexDirection: 'column' } }}>
                        <div css={{ width: 350 }}>
                            <strong>{term}:</strong>
                        </div>
                        <div css={{ flex: 1 }}>
                            {definitions2[term]}
                        </div>
                    </div>
                ))}
            </div>
        </Static>
    </Layout>
);
